import { AnalysisHistoryListItem } from '@/common/api/params/mediaAnalysis'
import {
  analysisStatusBadgeType,
  analysisStatusLabel,
  analysisTypeLabel
} from '@/common/app/modules/media/mediaAnalysis'
import { mediaActionPath, mediaAnalysisResultPath } from '@/common/app/path'
import { dateTimeStr } from '@/common/form/date'
import { isLLMOAnalysisType } from '@/common/model/media/mediaAnalysis'

import Badge, { BadgeType } from '@/components/view/atoms/badge/Badge'
import TextButton from '@/components/view/atoms/button/TextButton'
import ClickableTableRow from '@/components/view/atoms/table/ClickableTableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'
import ItemAlign from '@/components/view/layouts/item/ItemAlign'

interface Props {
  siteId: number
  item: AnalysisHistoryListItem
}

const MediaAnalysisHistoryListRow = ({ siteId, item }: Props) => {
  const resultPath = mediaAnalysisResultPath(siteId, item.analysis_type, item.id)

  return (
    <ClickableTableRow href={resultPath ?? undefined}>
      <TableRowItem width={160}>
        <Text size={12}>{item.created_at ? dateTimeStr(item.created_at) : '-'}</Text>
      </TableRowItem>
      <TableRowItem width={64}>
        <Text size={12}>{item.id}</Text>
      </TableRowItem>
      <TableRowItem>
        <ItemAlign justify='between'>
          <Text size={14} truncate>
            {analysisTypeLabel(item.analysis_type) + ' ' + item.summary}
          </Text>
          {resultPath && (
            <TextButton link={resultPath} arrow>
              結果を見る
            </TextButton>
          )}
        </ItemAlign>
      </TableRowItem>
      <TableRowItem width={128}>
        <Text>{isLLMOAnalysisType(item.analysis_type) ? 'GEO/LLMO' : 'SEO'}</Text>
      </TableRowItem>
      <TableRowItem width={88}>
        <Badge size={10} badgeType={analysisStatusBadgeType(item.status)}>
          {analysisStatusLabel(item.status)}
        </Badge>
      </TableRowItem>
      <TableRowItem width={88}>
        <Badge size={10} badgeType={BadgeType.DEFAULT}>
          {item.execution_source === 'scheduled' ? '自動' : '手動'}
        </Badge>
      </TableRowItem>
      <TableRowItem width={128}>
        {item.generated_action_count > 0 ? (
          <TextButton link={`${mediaActionPath(siteId)}?sourceAnalysisId=${item.id}`} arrow>
            {item.generated_action_count}件
          </TextButton>
        ) : (
          <Text size={12} color={TextColor.SECONDARY}>
            -
          </Text>
        )}
      </TableRowItem>
    </ClickableTableRow>
  )
}

export default MediaAnalysisHistoryListRow
